import { gql } from 'graphql-request';

export const UPDATE_MEMBER_MUTATION = gql`
  mutation updateMember($input: UpdateMemberInput!) {
    updateMember(input: $input) {
      ok
      error {
        code
        message
      }
    }
  }
`;
